'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "useTooltip_unstable", {
    enumerable: true,
    get: function() {
        return useTooltip_unstable;
    }
});
const _useTooltipBase = require("./useTooltipBase");
const useTooltip_unstable = (props)=>{
    'use no memo';
    const { appearance = 'normal' } = props;
    const state = (0, _useTooltipBase.useTooltipBase_unstable)(props);
    return {
        appearance,
        ...state
    };
};
